import React from 'react';
import { ZODIAC_SIGNS } from '../data/astroData';
import { useLanguage } from '../context/LanguageContext';

export default function ZodiacSelector({ selectedSign, onSelect }) {
  const { language } = useLanguage();
  const isTelugu = language === 'te';

  return (
    <div className="zodiac-grid">
      {ZODIAC_SIGNS.map((sign, index) => (
        <div
          key={sign.name}
          className={`zodiac-card ${selectedSign === sign.name ? 'selected' : ''}`}
          onClick={() => onSelect(sign.name)}
        >
          <div className="zodiac-circle">
            <img
              src={`/images/horoscope/${index + 1}.png`}
              alt={sign.name}
              className="zodiac-image"
            />
          </div>
          <span className="rashi-name">{isTelugu ? sign.rashiTe : sign.rashi}</span>
          <span className="name">{isTelugu ? sign.nameTe : sign.name}</span>
        </div>
      ))}
    </div>
  );
}
